import { signal } from '@angular/core';

export const darkModeSignal = signal(false);
